export function getGoogleClientId(form: HTMLFormElement): string | null {
  if (form) {
    const active: boolean = form.dataset.gmp === "true"

    if (active) {
      try {
        return ga.getAll()[0].get("clientId") ?? ""
      } catch (e) {
        // Ignore error, because it's not a functional requirement
        // Default it's an alphanumeric string
        // like "a8a5a8ah1". This does not break anything, 
        // but it disables correct tracking in Google Analytics,
        // because the user actions cannot be 
        // traced with that clientId.
      }
    }
  }

  return null
}

export function getGoogleClientIdOrFallback(form: HTMLFormElement): string {
  console.warn("Deprecated getGoogleClientIdOrFallback function, use getGoogleClientId instead.")

  return getGoogleClientId(form)
}

type GoogleSessionId = string | null | undefined

declare global {
  interface Window {
    gtag?: (
      method: string,
      googleID: string,
      property: string,
      callback: (id: GoogleSessionId) => void
    ) => void;
  }
}

/**
 * DO NOT AWAIT THIS FUNCTION, IT MAY NEVER RESOLVE FOR USERS WITH ADBLOCKERS!
 *
 * Not being able to complete a checkout seems a real conversion killer ;)
 *
 * Use it non-blocking, like: `getGoogleSessionID(googleID).then(sessionId => { ... })`
 * @param googleID
 */
export async function getGoogleSessionID(googleID: string): Promise<GoogleSessionId> {
  return new Promise<GoogleSessionId>((resolve, reject) => {
    if (!googleID) {
      reject(new Error("Google Analytics 4 tag ID is not defined."))
    }

    if (typeof window.gtag === "function") {
      window.gtag("get", googleID, "session_id", (id: GoogleSessionId) => {
        if (!id) {
          reject(new Error("Google Session ID could not retrieved, GA4 tag ID is not correct."))
        }
        resolve(id);
      });
    } else {
      reject(new Error(
        "GTAG does not exists on window, " +
        "did you install https://developers.google.com/tag-platform/gtagjs/install",
      ))
    }
  })
}
